// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '9df661d4-89fa-465c-8c84-3f5c0f1bbca5',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'buttonNineSlice',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 168,
        y: 55
      },
      width: 336,
      height: 110,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Grey',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'grey'
      },
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ButtonLargeLayout {
  static raw = raw;
  root: Container;
  buttonNineSlice: NineSlicePlane & { data: typeof raw['list'][1]['data'] };

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      buttonNineSlice: typeof raw['list'][1];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
